import PropTypes from 'prop-types';
import React from 'react';
import { Link, withRouter } from 'found';
import { Container, Grid, Icon, Item, Segment } from 'semantic-ui-react';
import MobileHeader from '../App/MobileHeader';
import withAuth from '../App/Authenticate';
import { Analytics, AvailabilityChecker } from '../Modules';
import styles from './Leads.scss';

const LeadCaptureComponent = class LeadCaptureComponent extends React.Component {
  static propTypes = {
    toggleSidebar: PropTypes.func,
    sidebarOpen: PropTypes.bool,
    viewer: PropTypes.object,
    router: PropTypes.object.isRequired
  };

  componentDidMount() {
    Analytics.trackEvent('viewed-lead-capture');
  }

  render() {
    const { router, sidebarOpen, toggleSidebar, viewer } = this.props;
    return (
      <Container>
        <Segment style={{ marginTop: '2em' }}>
          <MobileHeader viewer={viewer} router={router}>
            <div className='menu'>
              <Item
                as='a'
                className={sidebarOpen ? 'active ' : ''}
                onClick={toggleSidebar}
              >
                <Icon name='sidebar' />
              </Item>
            </div>
            <div className='right menu'>
              <AvailabilityChecker viewer={viewer} mobile />
              <Item as='a' onClick={router.push.bind(null, '/search')}>
                <Icon name='search' />
              </Item>
            </div>
          </MobileHeader>
          <Grid
            padded
            relaxed
            stackable
            style={{ textAlign: 'center', padding: '2em' }}
          >
            <Grid.Row>
              <Grid.Column>
                <h1>Collect event leads from anywhere.</h1>
                <h3 style={{ fontWeight: 'normal' }}>
                  Please select an option to continue.
                </h3>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns='equal' style={{ paddingTop: '3em' }}>
              <Grid.Column>
                <Link to='/leads/link'>
                  <p className={styles.icon}>
                    <Icon name='linkify' />
                  </p>
                  <h3>Contact Link</h3>
                  <p className={styles.description}>
                    Add a link anywhere to send prospects to your contact form
                  </p>
                  <p className={styles.easy}>
                    Easy Setup &mdash; Non-Technical
                  </p>
                </Link>
              </Grid.Column>
              <Grid.Column>
                <Link to='/leads/kiosk'>
                  <p className={styles.icon}>
                    <Icon name='tablet alternate' />
                  </p>
                  <h3>Bridal Show Kiosk</h3>
                  <p className={styles.description}>
                    Set up a kiosk to collect leads directly from prospects at
                    shows
                  </p>
                  <p className={styles.easy}>
                    Easy Setup &mdash; Non-Technical
                  </p>
                </Link>
              </Grid.Column>
              <Grid.Column>
                <Link to='/leads/embed'>
                  <p className={styles.icon}>
                    <Icon name='code' />
                  </p>
                  <h3>Custom Website Embed</h3>
                  <p className={styles.description}>
                    Collect leads directly from your website contact form
                  </p>
                  <p className={styles.difficult}>
                    Advanced Setup &mdash; Technical
                  </p>
                </Link>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </Container>
    );
  }
};

export default withRouter(withAuth(LeadCaptureComponent));



// WEBPACK FOOTER //
// ./webpack/components/Leads/LeadCaptureComponent.js